import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import EnvelopeOverlay from "@/components/EnvelopeOverlay";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Countdown from "@/components/Countdown";
import FamilyNote from "@/components/FamilyNote";
import EventSchedule from "@/components/EventSchedule";
import BaraatJourney from "@/components/BaraatJourney";
import RsvpSection from "@/components/RsvpSection";
import Footer from "@/components/Footer";
import Petals from "@/components/Petals";
import MusicPlayer from "@/components/MusicPlayer";
import GuestListPage from "@/components/GuestListPage";

export default function App() {
    const [opened, setOpened] = useState(false);
    const [musicStarted, setMusicStarted] = useState(false);

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    useEffect(() => {
        document.body.style.overflow = opened ? "" : "hidden";
        return () => {
            document.body.style.overflow = "";
        };
    }, [opened]);

    const home = (
        <div className="wedding-app relative">
            <div className="grain-overlay" />
            <AnimatePresence>
                {!opened && (
                    <EnvelopeOverlay
                        key="envelope"
                        onOpenStart={() => setMusicStarted(true)}
                        onOpen={() => setOpened(true)}
                    />
                )}
            </AnimatePresence>
            <Petals opened={opened} />
            <MusicPlayer started={musicStarted} opened={opened} />
            <main>
                <Hero opened={opened} />
                <Marquee />
                <Countdown />
                <FamilyNote />
                <EventSchedule />
                <BaraatJourney />
                <RsvpSection />
            </main>
            <Footer />
        </div>
    );

    return (
        <BrowserRouter>
            <Toaster position="top-center" richColors />
            <Routes>
                <Route path="/" element={home} />
                <Route path="/guest-list" element={<GuestListPage />} />
            </Routes>
        </BrowserRouter>
    );
}
